export class AgreementTermModification {
    termModificationType: number;
    adjustByMonths: number;
    newEndDate: Date;
}


// WEBPACK FOOTER //
// ./src/app/report/models/agreement-term-modification.model.ts